<template>
  <div class="w-100">
    <div class="p-4 mb-4 pb-2 rounded-6 box-shadow-main bg-white border">
      <div
        class="d-flex justify-content-between align-items-start cursor-pointer"
        v-b-toggle.detail_sr>
        <div class="mr-md-4 mr-3">
          <img src="../../../../assets/img/icon/request.png" width="40" />
        </div>
        <div class="w-100">
          <p class="mb-2 body-2-2 text-20 font-bold">
            {{ getMerchant().cart_special_request_title }}
          </p>
          <p class="mb-0 body-2-2 font-regular">
            {{ getMerchant().cart_special_request_subtitle }}
          </p>
        </div>
        <div>
          <svg
            width="24"
            height="20"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.3687 0.290009L18.7087 2.63C19.0988 3.01999 19.0988 3.64999 18.7087 4.04001L16.8788 5.87L13.1288 2.12L14.9587 0.290009C15.1487 0.100006 15.3987 0 15.6588 0C15.9188 0 16.1688 0.0899963 16.3687 0.290009ZM0.998749 14.25V18H4.74875L15.8087 6.94L12.0587 3.19L0.998749 14.25ZM3.91876 16H2.99875V15.08L12.0587 6.01999L12.9788 6.94L3.91876 16Z"
              class="fill-primary" />
          </svg>
        </div>
      </div>
      <b-collapse id="detail_sr" class="mt-4">
        <div class="mb-1">
          <div class="row">
            <div
              class="col-6 mb-3 position-relative"
              v-for="(item, index) in list">
              <SpecialRequestItem
                @submit="assignData"
                :item="item"
                :index="{ index: index, total: list.length }">
              </SpecialRequestItem>
            </div>
          </div>
        </div>
        <div class="mb-3 pb-2">
          <form>
            <div class="row mt-3">
              <div
                v-if="
                  getMerchant().is_show_special_request_checkin_in_checkin_out
                "
                class="col-6">
                <p
                  class="mb-0 bg-white body-2 text-12 font-regular px-1 delay"
                  v-show="show_label.in"
                  :class="{ 'label-active': show_label.in }">
                  {{ $t('hotel.date.check-in') }}
                </p>
                <input
                  type="time"
                  class="form-control body-2-2 font-semibold text-14 mb-1"
                  :placeholder="$t('hotel.date.check-in')"
                  @focus="toggleLabel('in')"
                  @blur="toggleLabel('in', false)"
                  v-model="form.in"
                  @change="submit()" />
                <p class="mb-0 body-2 font-regular text-14 sub-label">
                  {{ $t('hotel.special-request.request-check-in') }}
                </p>
              </div>
              <div
                v-if="
                  getMerchant().is_show_special_request_checkin_in_checkin_out
                "
                class="col-6">
                <p
                  class="mb-0 bg-white body-2 text-12 font-regular px-1 delay"
                  v-show="show_label.out"
                  :class="{ 'label-active': show_label.out }">
                  {{ $t('hotel.date.check-out') }}
                </p>
                <input
                  type="time"
                  class="form-control body-2-2 font-semibold text-14 mb-1"
                  :placeholder="$t('hotel.date.check-out')"
                  @focus="toggleLabel('out')"
                  @blur="toggleLabel('out', false)"
                  v-model="form.out"
                  @change="submit()" />
                <p class="mb-0 body-2 font-regular text-14 sub-label">
                  {{ $t('hotel.special-request.request-check-out') }}
                </p>
              </div>
              <div class="col-12">
                <div class="mt-4">
                  <textarea
                    class="form-control w-100 body-2-2 font-semibold text-14"
                    rows="4"
                    :placeholder="$t('hotel.special-request.other-request')"
                    @focus="toggleLabel('note')"
                    @blur="toggleLabel('note', false)"
                    v-model="form.note"
                    @change="submit()"></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import { get } from '@/services/index.js';
import { mapGetters, mapMutations } from 'vuex';
import SpecialRequestItem from '@/components/hotel/be/desktop/specialRequestItem.vue';
export default {
  components: {
    SpecialRequestItem,
  },
  data() {
    return {
      special_request_active: '',
      show_label: {
        check_in: false,
        check_out: false,
        note: false,
      },
      form: {
        check_in: '',
        check_out: '',
        note: '',
      },
      is_load: false,
      list: [],
      form: {
        in: '',
        out: '',
        note: '',
      },
      show_label: {
        in: false,
        out: false,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapGetters(['getMerchant', 'getBeCart']),
    ...mapMutations(['BeManipulateSpecialReq']),
    loadData() {
      this.is_load = true;
      this.list = [];
      get('CORE_HOTEL', 'hotel-special-request', {
        merchant_id: this.getMerchant().id,
      }).then((response) => {
        let res = response.data;
        if (res.success) {
          for (let item of res.data) {
            let record = this.getBeCart().special_request.findIndex(
              (x) => x.data.id == item.id
            );
            let copied_data = Object.assign(
              {},
              this.getBeCart().special_request[record]
            );
            let params = {
              data: item,
              is_checked: record != -1 ? true : false,
              note: record != -1 ? copied_data.note : '',
            };
            this.list.push(params);
          }
          this.form = {
            in: this.getBeCart().custom_time.check_in,
            out: this.getBeCart().custom_time.check_out,
            note: this.getBeCart().note,
          };
        } else {
          console.log('Error while load special request : ', res.message);
        }
        this.is_load = false;
      });
    },
    assignData(data) {
      let local = JSON.parse(JSON.stringify(data.data));
      this.list[data.index] = local;
      this.submit();
    },
    toggleLabel(key, focus = true) {
      this.show_label[key] = focus || this.form[key] != '' ? true : false;
    },
    submit() {
      let item_list = this.list.filter((x) => x.is_checked);
      let params = {
        special_request: item_list,
        time: {
          check_in: this.form.in,
          check_out: this.form.out,
        },
        note: this.form.note,
      };

      this.BeManipulateSpecialReq(params);
      this.close();
    },
    close() {
      this.$emit('close', 'close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/desktop/specialRequest.vue